import React from "react";
import { Card } from "@/components/ui/card";
import { Clock, ShieldCheck, Star, BadgeCheck, FileText, Camera } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export function CredentialsStrip() {
  const { lang } = useLang();
  const items = lang === "it" ? [
    { icon: Clock, value: "H24", label: "Reperibilità 7/7" },
    { icon: FileText, value: "Scritto", label: "Preventivo prima di iniziare" },
    { icon: ShieldCheck, value: "Mirata", label: "Diagnosi non invasiva ove possibile" },
    { icon: Camera, value: "Report", label: "Foto e relazione tecnica" },
    { icon: Star, value: "Google", label: "Profilo Business ufficiale" },
    { icon: BadgeCheck, value: "P.IVA", label: "Ditta regolare" },
  ] : [
    { icon: Clock, value: "24/7", label: "Phone availability" },
    { icon: FileText, value: "Written", label: "Quote before we start" },
    { icon: ShieldCheck, value: "Targeted", label: "Non-invasive where possible" },
    { icon: Camera, value: "Report", label: "Photos and technical report" },
    { icon: Star, value: "Google", label: "Official Business profile" },
    { icon: BadgeCheck, value: "VAT", label: "Registered company" },
  ];
  return (
    <div className="grid grid-cols-3 sm:grid-cols-6 gap-2 sm:gap-3" data-testid="credentials-strip">
      {items.map((it) => {
        const Icon = it.icon;
        return (
          <Card key={`cred-${it.label}`} className="p-3 sm:p-4 text-center card-hover">
            <Icon className="h-5 w-5 sm:h-6 sm:w-6 mx-auto text-[hsl(var(--brand-aqua))]" />
            <div className="mt-1.5 text-base sm:text-lg font-bold text-[hsl(var(--brand-navy))] leading-none">{it.value}</div>
            <div className="mt-1 text-[10px] sm:text-xs text-[hsl(var(--muted-foreground))] leading-tight">{it.label}</div>
          </Card>
        );
      })}
    </div>
  );
}

export default CredentialsStrip;
